import React, { type ReactElement } from 'react';
import ConfirmModal, { ConfirmModalActionPair } from 'atom-components/confirm-modal';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  responseId: number;
};

export default function ConfirmReloadTableModal({
  isOpen,
  onClose,
  onConfirm,
  responseId
}: Props): ReactElement {
  return (
    <ConfirmModal
      isOpen={isOpen}
      title="Confirm Reload Table"
      handleClickCancel={onClose}
      handleClickOK={onConfirm}
      actionPair={ConfirmModalActionPair.Custom}
      buttonTitleOK="Reload Table"
      showCancelButton={false}
    >
      <p>
        No markers are allocated to <b>response #{responseId}</b>.
      </p>
      <p>
        The Marking Allocation table may be out of date. Please reload the table to see the updated
        marker count for this response.
      </p>
    </ConfirmModal>
  );
}
